const MenuModules: { [key: number]: any } = {
    1: {
        heading: 'aside.menu.pages.modules.forms',
        fontIcon: 'bi-card-text',
        sub: [
            {
                heading: 'aside.menu.pages.modules.formsAdd',
                route: '/modules/forms',
            },
            {
                heading: 'aside.menu.pages.modules.formsList',
                roles: ['ROLE_ADMIN', 'ROLE_BOSS'],
                route: '/modules/forms/list',
            },
            {
                heading: 'aside.menu.pages.modules.formsReport',
                roles: ['ROLE_ADMIN', 'ROLE_BOSS'],
                parameters: ['HOSPITAL_WORK_CARD'],
                route: '/modules/forms/report',
            }
        ]
    }
};

export default MenuModules;
